export default __webpack_public_path__ + "static/media/autoconsumo-individual-con-excedentes-compensacion-mvl.ad8acd72.png";